import React, { useState, useEffect } from 'react';
import css from './PublicPageWrapper.css';
import Collapse from '@kunukn/react-collapse';
import {
  Menu as MenuIcon,
  Grid,
  FileText,
  ChevronDown,
  ChevronUp,
  Calendar,
  Volume2,
  Mail,
  Bell,
  PieChart,
  ChevronLeft,
  Users,
  User,
  UserPlus,
  CreditCard,
  Settings,
  Link2,
  Search,
  Video,
} from 'react-feather';
import { marketplaceLockupLogo as AppLogo } from '../../assets/viveka-logos';
import { Link, NavLink, withRouter } from 'react-router-dom';
import config from '../../config';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Menu, MenuItem, SubMenu } from '@szhsin/react-menu';
import { logout } from '../../ducks/Auth.duck';
import defaultProfilePic from '../../assets/default_profile.png';
import classNames from 'classnames';
import { fetchPendingEnquiriesCount } from '../../custom-ducks/clients.duck';

const PublicPageWrapper = props => {
  const {
    currentUser,
    children,
    title,
    page,
    history,
    logout,
    isAuthenticated,
    currentUserNotificationCount,
    currentUserHasOrders,
    onFetchPendingEnquiriesCount,
  } = props;

  const [isVCorpOpen, setIsVCorpOpen] = useState(true);
  const [isVCoachOpen, setIsVCoachOpen] = useState(true);
  const [isVClientOpen, setIsVClientOpen] = useState(true);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [pendingInvitesCount, setPendingInvitesCount] = useState(0);

  const isProvider = currentUser?.attributes?.profile?.publicData?.isProvider;

  useEffect(() => {
    if (!isProvider || !onFetchPendingEnquiriesCount) return;
    onFetchPendingEnquiriesCount()
      .then(count => setPendingInvitesCount(count || 0))
      .catch(() => setPendingInvitesCount(0));
  }, [isProvider, onFetchPendingEnquiriesCount]);

  const myCompanies =
    currentUser?.attributes?.profile?.metadata[`myCompanies${process.env.REACT_APP_ENVIRONMENT}`];
  const hasCompany = !!myCompanies;

  const currentCompany =
    currentUser?.attributes?.profile?.metadata[
      `currentCompany${process.env.REACT_APP_ENVIRONMENT}`
    ];
  const currentCompanyRoles = currentCompany?.roles || [];

  const showVClient =
    !isProvider || currentUserHasOrders || currentCompanyRoles.includes('employee');

  const isVCoachTheme =
    typeof document !== 'undefined' &&
    document.body.classList.contains('v-coach-theme');
  const menuHoverBg = isVCoachTheme ? '#7C3AED' : '#0D9488';
  const menuItemStyles = {
    color: '#0F172A',
    backgroundColor: 'white',
    hover: { backgroundColor: menuHoverBg, color: '#FFFFFF' },
    active: { backgroundColor: menuHoverBg, color: '#FFFFFF' },
  };

  return (
    <div className={css.base} style={{ display: isAuthenticated ? 'grid' : 'flex' }}>
      <div
        className={`${css.menu_base} ${isNavOpen && css.menu_open} ${!isAuthenticated && css.hide_menu}`}
      >
        <div className={css.menu_nav_top}>
          {isAuthenticated && (
            <Link to={'/s'} className={css.logo}>
              <img style={{ width: '100%' }} alt={'logo'} src={AppLogo} />
            </Link>
          )}
          <ChevronLeft
            className={css.menu_close_button}
            onClick={() => setIsNavOpen(false)}
          />
        </div>
        <div className={classNames(css.section_wrapper)}>
          {currentCompany &&
            (currentCompanyRoles.includes('admin') || currentCompanyRoles.includes('hr')) && (
              <div className={css.menu_section}>
                <div
                  className={css.menu_item_wrapper}
                  onClick={() => setIsVCorpOpen(!isVCorpOpen)}
                >
                  <p>Organization</p>
                  {isVCorpOpen ? <ChevronUp /> : <ChevronDown />}
                </div>
                <Collapse isOpen={isVCorpOpen}>
                  <a
                    href={`${config.vCorpUrl}/hr/dashboard`}
                    target="_self"
                    className={`${css.collapse_item_wrapper} ${page === 'corp-dashboard' ? css.menu_item_active : ''}`}
                  >
                    <Grid />
                    <p>Dashboard</p>
                  </a>
                  <a
                    href={`${config.vCorpUrl}/hr/curriculum`}
                    target="_self"
                    className={`${css.collapse_item_wrapper} ${page === 'corp-curriculum' ? css.menu_item_active : ''}`}
                  >
                    <FileText />
                    <p>Curriculum</p>
                  </a>
                  <a
                    href={`${config.vCorpUrl}/hr/coach`}
                    target="_self"
                    className={`${css.collapse_item_wrapper} ${page === 'corp-coach' ? css.menu_item_active : ''}`}
                  >
                    <User />
                    <p>Coach</p>
                  </a>
                  <a
                    href={`${config.vCorpUrl}/hr/employee`}
                    target="_self"
                    className={`${css.collapse_item_wrapper} ${page === 'corp-employees' ? css.menu_item_active : ''}`}
                  >
                    <Users />
                    <p>Employees</p>
                  </a>
                  <a
                    href={`${config.vCorpUrl}/hr/billing/budget`}
                    target="_self"
                    className={`${css.collapse_item_wrapper} ${page === 'corp-billing' ? css.menu_item_active : ''}`}
                  >
                    <CreditCard />
                    <p>Billing</p>
                  </a>
                  <a
                    href={`${config.vCorpUrl}/hr/settings`}
                    className={`${css.collapse_item_wrapper} ${page === 'corp-settings' ? css.menu_item_active : ''}`}
                  >
                    <Settings />
                    <p>Settings</p>
                  </a>
                </Collapse>
              </div>
            )}

          {isProvider && (
            <div className={css.menu_section}>
              <div
                className={css.menu_item_wrapper}
                onClick={() => setIsVCoachOpen(!isVCoachOpen)}
              >
                <p>Coach</p>
                {isVCoachOpen ? <ChevronUp /> : <ChevronDown />}
              </div>
              <Collapse isOpen={isVCoachOpen}>
                <Link
                  to={`/v-coach/clients-activities`}
                  className={`${css.collapse_item_wrapper} ${page === 'coach-dashboard' ? css.menu_item_active : ''}`}
                >
                  <Video />
                  <p>Sessions</p>
                </Link>
                <Link
                  to={`/v-coach/clients`}
                  className={`${css.collapse_item_wrapper} ${page === 'coach-clients' ? css.menu_item_active : ''}`}
                >
                  <Users size={20} />
                  <p>Clients</p>
                </Link>
                <Link
                  to={`/v-coach/reports`}
                  className={`${css.collapse_item_wrapper} ${page === 'coach-reports' ? css.menu_item_active : ''}`}
                >
                  <PieChart size={20} />
                  <p>Reports</p>
                </Link>
                <Link
                  to={`/v-coach/programs`}
                  className={`${css.collapse_item_wrapper} ${page === 'coach-program' ? css.menu_item_active : ''}`}
                >
                  <FileText />
                  <p>Programs</p>
                </Link>
                <Link
                  to={`/listings`}
                  className={`${css.collapse_item_wrapper} ${page === 'coach-ads' ? css.menu_item_active : ''}`}
                >
                  <Volume2 size={20} />
                  <p>Ads</p>
                </Link>
                <Link
                  to={`/saas-chats/coach`}
                  className={`${css.collapse_item_wrapper} ${page === 'coach-messages' ? css.menu_item_active : ''}`}
                >
                  <Mail />
                  <p>Messages</p>
                </Link>
                <Link
                  to={`/referral_program`}
                  className={`${css.collapse_item_wrapper} ${page === 'coach-referral' ? css.menu_item_active : ''}`}
                >
                  <UserPlus size={20} />
                  <p>Referrals</p>
                </Link>
                <Link
                  to={`/s`}
                  className={`${css.collapse_item_wrapper} ${page === 'client-marketplace' ? css.menu_item_active : ''}`}
                >
                  <Search size={20} />
                  <p>Find A Coach</p>
                </Link>
              </Collapse>
            </div>
          )}

          {showVClient && (
            <div className={css.menu_section}>
              <div
                className={css.menu_item_wrapper}
                onClick={() => setIsVClientOpen(!isVClientOpen)}
              >
                <p>Participant</p>
                {isVClientOpen ? <ChevronUp /> : <ChevronDown />}
              </div>
              <Collapse isOpen={isVClientOpen}>
                {hasCompany && (
                  <a
                    href={`${config.vCorpUrl}/employee/company/my-curriculums`}
                    className={css.collapse_item_wrapper}
                  >
                    <FileText />
                    <p>{currentCompany?.name || 'My Company'}</p>
                  </a>
                )}
                <Link
                  to={`/v-coach/client/dashboard`}
                  className={`${css.collapse_item_wrapper} ${page === 'client-dashboard' ? css.menu_item_active : ''}`}
                >
                  <Video />
                  <p>Sessions</p>
                </Link>
                <Link
                  to={`/saas-chats/client`}
                  className={`${css.collapse_item_wrapper} ${page === 'client-messages' ? css.menu_item_active : ''}`}
                >
                  <Mail />
                  <p>Messages</p>
                </Link>
                <Link
                  to={`/inbox/orders`}
                  className={`${css.collapse_item_wrapper} ${page === 'client-purchases' ? css.menu_item_active : ''}`}
                >
                  <CreditCard size={20} />
                  <p>Purchases</p>
                </Link>
              </Collapse>
            </div>
          )}

          {!isProvider && (
            <Link
              to={`/s`}
              className={`${css.collapse_item_wrapper} ${page === 'client-marketplace' ? css.menu_item_active : ''}`}
            >
              <Search size={20} />
              <p className=" text-ellipsis overflow-hidden whitespace-nowrap">Find A Coach</p>
            </Link>
          )}

          <div className={css.public_links}>
            <hr />
            <div className={css.menu_section}>
              <Link to={`/how-it-works`} className={css.collapse_item_wrapper}>
                <Link2 />
                <p>How it works</p>
              </Link>
              <Link to={`/enterprise`} className={css.collapse_item_wrapper}>
                <Link2 />
                <p>Enterprise</p>
              </Link>
              <a href={`/coach`} className={css.collapse_item_wrapper}>
                <Link2 />
                <p>Coach</p>
              </a>
              <Link to={`/individual`} className={css.collapse_item_wrapper}>
                <Link2 />
                <p>Individual</p>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className={css.content_base} style={{ width: !isAuthenticated ? '100vw' : '' }}>
        <div className={css.nav_bar}>
          <div
            id="leftItems"
            style={{ display: 'flex', marginLeft: '20px', alignItems: 'center' }}
          >
            <MenuIcon className={css.menu_button} onClick={() => setIsNavOpen(true)} />
            {!isAuthenticated && (
              <a className={css.logo} href="/">
                <img style={{ width: '100%' }} alt={'logo'} src={AppLogo} />
              </a>
            )}
            <div className={css.nav_links}></div>
            <p className="pl-2 m-0 text-xl font-semibold">{title}</p>
          </div>
          <div className={css.nav_actions}>
            {isAuthenticated ? (
              <>
                {isProvider && (
                  <div
                    style={{ position: 'relative', cursor: 'pointer', marginRight: '14px' }}
                    onClick={() => history.push('/inbox/sales')}
                    title="Pending client enquiries — go to Inbox to accept or decline"
                  >
                    <Bell className={css.nav_message_button} />
                    {pendingInvitesCount > 0 && (
                      <div
                        className="animate-pulse"
                        style={{
                          position: 'absolute',
                          top: -8,
                          right: -10,
                          minWidth: 22,
                          height: 22,
                          padding: '0 6px',
                          borderRadius: 11,
                          background: '#EF4444',
                          color: '#FFFFFF',
                          fontSize: 12,
                          fontWeight: 700,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          lineHeight: 1,
                          boxShadow: '0 0 0 2px #FFFFFF, 0 2px 6px rgba(239, 68, 68, 0.45)',
                        }}
                      >
                        {pendingInvitesCount}
                      </div>
                    )}
                  </div>
                )}
                <Mail
                  onClick={() => history.push('/public-messages')}
                  className={css.nav_message_button}
                  style={{ marginRight: 10, cursor: 'pointer' }}
                  title="Messages"
                />
                <Menu
                  direction="left"
                  menuButton={
                    <div className={css.avatar_wrapper}>
                      <div>
                        <img
                          className={css.profile_image}
                          alt="profile"
                          src={
                            currentUser?.profileImage?.attributes?.variants['square-small']?.url ||
                            defaultProfilePic
                          }
                        />
                      </div>
                      <div>
                        <p>{currentUser?.attributes?.profile.displayName}</p>
                      </div>
                    </div>
                  }
                >
                  {/* Dropdown items match MainDashboardWrapper exactly:
                      Profile / Settings / Logout. Earlier this menu had an
                      extra Clients link for coaches but that made the user
                      menu inconsistent across surfaces — coaches already
                      have a Clients link in the sidebar. */}
                  <MenuItem
                    styles={menuItemStyles}
                    onClick={() => {
                      history.push('/profile-settings');
                      return true;
                    }}
                  >
                    Profile
                  </MenuItem>
                  <MenuItem
                    styles={menuItemStyles}
                    onClick={() => {
                      history.push('/account-settings');
                      return true;
                    }}
                  >
                    Settings
                  </MenuItem>
                  <MenuItem
                    styles={menuItemStyles}
                    onClick={() => {
                      logout().then(() => history.push('/login'));
                      return true;
                    }}
                  >
                    Logout
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <div className={css.authActions}>
                <Link className={css.loginButton} to={'/login'}>
                  Login
                </Link>
                <Link className={css.signupButton} to={'/signup/type'}>
                  Sign Up
                </Link>
              </div>
            )}
          </div>
        </div>
        <div className={css.content}>{children}</div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const { currentUser, currentUserNotificationCount, currentUserHasOrders } = state.user;
  const { isAuthenticated } = state.Auth;
  return {
    currentUser,
    isAuthenticated,
    currentUserNotificationCount,
    currentUserHasOrders,
  };
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  onFetchPendingEnquiriesCount: () => dispatch(fetchPendingEnquiriesCount()),
});

export default withRouter(
  compose(connect(mapStateToProps, mapDispatchToProps))(PublicPageWrapper)
);
